import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const ReadingMeetups = () => <EventCategoryPage config={EVENT_CATEGORIES['reading-meetups']} data-id="element-9879" data-mp="1ludzzvn0559r" />;
export default ReadingMeetups;